import React, { useState, useEffect, useMemo, useRef } from 'react'
import Gallery from './Gallery/Gallery'
import CheckButton from './Gallery/CheckButton'
import CloseButton from '../icons/Close'
import Lightbox from './Lightbox.jsx'
import WebCamera from './WebCamera/webCam.jsx'
import Sortable from 'sortablejs'
import ReactDOM from 'react-dom'

export default (props) => {
    const [title, setTitle] = useState('')
    const [options, setOptions] = useState([])
    const [images, setImages] = useState([])
    const [selectAllChecked, setSelectAllChecked] = useState(false)
    const [isLightboxOpen, setIsLightboxOpen] = useState(false)
    const [isNew, setIsNew] = useState(false)

    const gallery = useRef(null)

    useEffect(() => {
        setImages(props.images)
        setTitle(props.title)
        setOptions(props.options)

        // I think this version breaks if you have more than 1 gallery and causes memory leaks
        // It may just be when they're both uncommented the bottom one keeps a reference to an old ImageGallery
        // DOM node and stops them from getting garbage collected and least on IE
        // There are a few situations where IE won't be smart about it
        // 2 pieces of garbage can have references to each other and keep each other alive
        // Something you're keeping alive like the gallery ref could keep refences to old DOM nodes on accident
        // NOTE: these were never uncommented together previously -- see commit a209584cab8545b8726ab476239325963fe55245
        // document.getElementsByClassName('ReactGridGallery').forEach(gallery => {
        //     Sortable.create(
        //         gallery, {
        //         onEnd: onGalleryImageSort,
        //         animation: 150
        //     });
        // })

        // Sortable.create(
        //     ReactDOM.findDOMNode(gallery.current), {
        //     onEnd: onGalleryImageSort,
        //     animation: 100
        // });
    }, [props.images, props.title, props.options])

    const onGalleryImageSort = (evt) => props.onSortPicture(evt.oldIndex, evt.newIndex)

    const allImagesSelected = (images) => {
        return getSelectedImages().length === images.length
    }

    const onSelectImage = (i, img) => {
        var imgs = images.slice()
        if (img.hasOwnProperty('isSelected')) img.isSelected = !img.isSelected
        else img.isSelected = true

        setImages(imgs)

        if (allImagesSelected(imgs)) setSelectAllChecked(true)
        else setSelectAllChecked(false)
    }

    const getSelectedImages = () => {
        return images.filter((img) => {
            return img.isSelected === true
        })
    }

    const onClickSelectAll = () => {
        var imgs = images.slice()
        if (!selectAllChecked) for (var i = 0; i < images.length; i++) imgs[i].isSelected = true
        else for (var i = 0; i < images.length; i++) imgs[i].isSelected = false

        setSelectAllChecked(!selectAllChecked)
        setImages(imgs)
    }

    const onClickAddPicture = () => {
        setIsNew(true)
        setIsLightboxOpen(true)
    }

    const onClickRemoveSelectedPictures = () =>
        props.onClickRemoveSelectedPictures(getSelectedImages())

    const onClickImage = () => {
        const backdrop = document.getElementById('lightboxBackdrop')
        if (backdrop) backdrop.click()
    }

    const onDrop = (e) => {
        e.stopPropagation()
        e.preventDefault()
        let reader = new FileReader()
        reader.addEventListener(
            'load',
            function () {
                let uri = reader.result
                props.onAddPicture(uri, [], '')
            },
            false
        )
        if (e.dataTransfer.files[0].type.includes('image')) {
            reader.readAsDataURL(e.dataTransfer.files[0])
        } else {
            alert('Dropped file is not an image')
        }
    }

    return (
        <div
            name={props.name}
            style={{
                width: '100%',
            }}
        >
            {images.length === 0 && (
                <input
                    className="validation-dummy"
                    style={{ height: '50px', width: '127px' }}
                    onKeyPress={(e) => e.preventDefault()}
                    required={props.required}
                ></input>
            )}
            {
                <Lightbox
                    title={title}
                    options={options}
                    currentImage={null}
                    selectedOptions={null}
                    currentCaption={null}
                    isOpen={isNew && isLightboxOpen}
                    setIsLightboxOpen={(bOpen) => {
                        if (!bOpen) setIsNew(false)
                        setIsLightboxOpen(bOpen)
                    }}
                    disabled={props.disabled}
                    onAddPicture={props.onAddPicture}
                    onUpdateFields={props.onUpdateFields}
                />
            }
            {images.length > 0 && !props.disabled && (
                <span>
                    <CheckButton
                        index={0}
                        isSelected={selectAllChecked}
                        onClick={onClickSelectAll}
                        parentHover={true}
                        color={'rgba(0,0,0,0.54)'}
                        selectedColor={'#4285f4'}
                        hoverColor={'rgba(0,0,0,0.54)'}
                    />
                    <div
                        style={{
                            height: '36px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        Select All
                    </div>
                </span>
            )}
            <div
                style={{
                    alignItems: 'center',
                    display: 'flex',
                    maxWidth: '620px',
                    padding: '10px',
                }}
            >
                <button
                    className="btn btn-sm btn-success"
                    style={{
                        marginRight: '15px',
                    }}
                    type="button"
                    onClick={!props.disabled ? onClickAddPicture : null}
                >
                    {!props.disabled && <span className="glyphicon glyphicon-plus" />}&nbsp;
                    {props.disabled ? 'Locked ' : 'Add Picture'}
                </button>
                {!props.disabled && (
                    <button
                        className="btn btn-sm btn-info"
                        disabled={true}
                        type="button"
                        onClick={null}
                        onDrop={onDrop}
                    >
                        {'Drop Picture Here'}
                    </button>
                )}
                {images.length > 0 && !props.disabled && (
                    <button
                        className="btn btn-sm btn-danger"
                        style={{
                            marginLeft: 'auto',
                            marginRight: '15px',
                        }}
                        type="button"
                        disabled={getSelectedImages().length === 0}
                        onClick={onClickRemoveSelectedPictures}
                        title={
                            getSelectedImages().length === 0
                                ? 'Please select at least one image to delete.'
                                : ''
                        }
                    >
                        <span className="glyphicon glyphicon-remove-sign" />
                        &nbsp;Remove
                    </button>
                )}
            </div>
            <Gallery
                ref={gallery}
                disabled={props.disabled}
                images={images}
                selectedOptions={props.selectedOptions}
                rowHeight={props.rowHeight}
                lightboxTitle={title}
                lightboxOptions={options}
                lightboxIsOpen={!isNew && isLightboxOpen}
                setIsLightboxOpen={(bOpen) => setIsLightboxOpen(bOpen)}
                onSelectImage={onSelectImage}
                onAddPicture={props.onAddPicture}
                onUpdateFields={props.onUpdateFields}
            // onCaptionChange={props.onCaptionChange}
            // showLightboxThumbnails={true}
            // backdropClosesModal={true}
            // showCloseButton={true}
            // onClickImage={onClickImage}
            />
        </div>
    )
}
